export class PLANNEDSTOP {
    Type: string = "PLANNEDSTOP";
    MachineId: string;
    SerialNumber: string;
    StartDate: Date;
    EndDate: Date;
    SubtypeId: number;
    SubtypeDescription: string;
}